import { Button, Table } from 'react-bootstrap'

export const DraftPackagesTable = ({ packages, onClickPackage, onClickDeleteDraftPackage }) => {
  return (
    <Table className='blue-border-bottom'>
      <thead>
        <tr>
          <th>Turkey Tracking Number</th>
          <th>Quantity</th>
          <th>Brand</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {packages.map(p => {
          return (
            <tr key={p.id}>
              <td>{p.trackingNumberInTurkey}</td>
              <td>{p.totalQuantity}</td>
              <td>{p.brand}</td>
              <td>
                <Button block variant='primary' onClick={() => onClickPackage(p)}>
                  Continue
                </Button>
                <Button block variant='danger' style={{ backgroundColor: 'red' }} onClick={() => onClickDeleteDraftPackage(p)}>
                  Delete
                </Button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}
